import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

export const CoffeeIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='100%'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M3 14c.83.642 2.077 1.017 3.5 1 1.423.017 2.67-.358 3.5-1 .83-.642 2.077-1.017 3.5-1 1.423-.017 2.67.358 3.5 1' />
    <path d='M8 3a2.4 2.4 0 0 0-1 2 2.4 2.4 0 0 0 1 2' />
    <path d='M12 3a2.4 2.4 0 0 0-1 2 2.4 2.4 0 0 0 1 2' />
    <path d='M3 10h14v5a6 6 0 0 1-6 6h-2a6 6 0 0 1-6-6v-5z' />
    <path d='M16.746 16.726a3 3 0 1 0 .252-5.555' />
  </Icon>
);

export default CoffeeIcon;
